import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { AlertRulesScreen } from '@/features/alerts/alert-rules-screen'
import { useEffectiveGrants } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/settings/alerts')({
  component: AlertSettingsRoute,
})

function AlertSettingsRoute() {
  const { can } = useEffectiveGrants()
  const navigate = useNavigate()
  if (!can('alert.edit')) {
    void navigate({ to: '/alerts', search: { type: undefined, page: 1 } })
    return null
  }
  return <AlertRulesScreen />
}
